import { OpenAI } from "openai";
import { zodResponseFormat } from "openai/helpers/zod";
import { ChatCompletionMessageParam } from "openai/resources/index.mjs";
import { ZodObject } from "zod";
import { getSettings, Settings } from "./SettingsService";

export interface Prompt {
  systemPrompt: string;
  userPrompt: string;
}

function getApi(settings: Settings) {
  const apiKey = settings.openaiApiKey;
  if (!apiKey) {
    throw new Error(
      "Set up OpenAI apikey in TwinVerse settings (top left corner on screen)"
    );
  }
  const openai = new OpenAI({ apiKey, dangerouslyAllowBrowser: true });
  return openai;
}

function makeMessages(prompt: Prompt): ChatCompletionMessageParam[] {
  return [
    { role: "system", content: prompt.systemPrompt },
    { role: "user", content: prompt.userPrompt },
  ];
}

function processOpenAIError(error: any) {
  console.error(error);
  try {
    if (error instanceof Error) {
      // OpenAI SDK replaces the api by very long string of ***, it's annoying and common
      error.message = error.message.replace(/\*{4,}/g, "***");
    }
  } catch (err2) {
    //ignore the error about processing errors...
    console.info("Error processing error message, continue", err2);
  }
  return error;
}

export async function runStructuredPrompt<T>(
  prompt: Prompt,
  returnSchema: ZodObject<any>
): Promise<T> {
  const settings = getSettings();
  const openai = getApi(settings);
  const messages = makeMessages(prompt);
  const model = settings.model;
  const response_format = zodResponseFormat(returnSchema, "return_object"); // return_object is a dummy variable here, not used
  console.info("Running prompt:", messages, "model:", model);
  try {
    const completion = await openai.beta.chat.completions.parse({
      model,
      messages,
      response_format,
      temperature: 0,
    });
    console.info(
      "LLM response:",
      completion,
      "First message:",
      completion.choices[0].message
    );
    const ret = completion.choices[0].message.parsed;
    return ret as T;
  } catch (error) {
    throw processOpenAIError(error);
  }
}
